// extracted by mini-css-extract-plugin
export default {"awardSelect":"awardSelect--mp-gs_Wy"};